export const investorTypes = [
  'Individual Sophisticated Investor',
  'Family Office',
  // 'Wholesale Investor',
  'Foundation',
  'NFP',
  'Corporate',
  'Financial Adviser',
  'Accountant',
  'Fund Manager',
  'Other Please state',
];

export const investorClassifications = ['Wholesale', 'Retail'];

export const contactOptions = [
  'Ask Questions',
  'Organise a call',
  'Organise a meeting',
  'Other',
];

export const userStatuses = {
  IN_REVIEW: 'In Review',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
};

export const assetStatuses = {
  DRAFT: 'Draft',
  PUBLISHED: 'Published',
};
